import axios from "axios";

const BASE_URL = process.env.REACT_APP_SERVER;

const endpoints = {
  default: "/api/v1/tickets",
  findTicketById: "/:id",
  updateTicketQR: "/:id/qr",
  validate: "/api/v1/tickets/validate",
  totalDailySales: "/sales",
  latestTicketSales: "/latest_sales",
  formQuestions: "/form_questions",
  delete: "/delete",
};

export function updateTicketQR(ticketID) {
  const requestUrl = `${BASE_URL}${endpoints.default}/${ticketID}/qr`;

  const token = window.localStorage.getItem("token");

  var config = {
    method: "patch",
    url: requestUrl,
    headers: {
      Authorization: `Bearer ${token}`,
      "x-api-key": process.env.REACT_APP_OOVAL_API_KEY,
    },
  };

  return axios(config);
}

export function checkTicketQR(QR, eventID) {
  const requestUrl = `${BASE_URL}${endpoints.validate}`;

  const token = window.localStorage.getItem("token");

  var config = {
    method: "post",
    url: requestUrl,
    headers: {
      Authorization: `Bearer ${token}`,
      "x-api-key": process.env.REACT_APP_OOVAL_API_KEY,
    },
    data: {
      scan_code: QR,
      event_id: eventID,
    },
  };

  return axios(config);
}

export async function getTickets({
  eventID,
  page,
  limit,
  apiKey,
  dayPeriod,
  types,
}) {
  let requestUrl =
    BASE_URL + endpoints.default + `?day_period=${dayPeriod || 0}`;

  if (limit) {
    requestUrl += `&limit=${limit}`;
  }

  if (page && limit) {
    requestUrl += `&skip=${(page - 1) * limit}`;
  }

  if (eventID) {
    requestUrl += `&event_id=${eventID}`;
  }

  if (types) {
    requestUrl += `&types=${types}`;
  }

  var config = {
    method: "get",
    url: requestUrl,
    headers: {
      "x-api-key": apiKey,
    },
  };

  try {
    const response = await axios(config);

    return response;
  } catch (err) {
    console.log(err);
    return { error: err.response.data };
  }
}

export async function getSalesOverview({ dayPeriod, apiKey, eventID, type }) {
  let requestUrl = `${BASE_URL}${endpoints.default}${endpoints.totalDailySales}?day_period=${dayPeriod}`;

  if (eventID) {
    requestUrl += `&event_id=${eventID}`;
  }

  if (type) {
    requestUrl += `&type=${type}`;
  }

  var config = {
    method: "get",
    url: requestUrl,
    headers: {
      "x-api-key": apiKey,
    },
  };

  try {
    const response = await axios(config);

    return response;
  } catch (err) {
    console.log(err);
    return { error: err.response.data };
  }
}

export async function getLatestTicketSales({ apiKey, eventID, amount }) {
  const requestUrl = `${BASE_URL}${endpoints.default}${endpoints.latestTicketSales}?ticket_amount=${amount}&event_id=${eventID}`;

  var config = {
    method: "get",
    url: requestUrl,
    headers: {
      "x-api-key": apiKey,
    },
  };

  try {
    const response = await axios(config);

    return response;
  } catch (err) {
    console.log(err);
    return { error: err.response.data };
  }
}

export async function createTicket({ apiKey, data }) {
  const requestUrl = `${BASE_URL}${endpoints.default}/create`;

  var config = {
    method: "post",
    url: requestUrl,
    headers: {
      "x-api-key": apiKey,
    },
    data,
  };

  try {
    const response = await axios(config);

    return response;
  } catch (err) {
    console.log(err);
    return { error: err.response.data };
  }
}

export async function getAnsweredQuestions({ eventID, apiKey, dayPeriod }) {
  const requestUrl = `${BASE_URL}${endpoints.default}${endpoints.formQuestions}?event_id=${eventID}&day_period=${dayPeriod}`;

  var config = {
    method: "get",
    url: requestUrl,
    headers: {
      "x-api-key": apiKey,
    },
  };

  try {
    const response = await axios(config);

    return response;
  } catch (err) {
    console.log(err);
    return { error: err.response.data };
  }
}

export async function deleteTicket({ apiKey, ticketID }) {
  const requestUrl = `${BASE_URL}${endpoints.default}${endpoints.delete}`;

  var config = {
    method: "delete",
    url: requestUrl,
    headers: {
      "x-api-key": apiKey,
    },
    data: {
      ticket_id: ticketID,
    },
  };

  try {
    const response = await axios(config);

    return response;
  } catch (err) {
    console.log(err);
    return { error: err.response.data };
  }
}
